<template>
    <div class="user">
        <div class="common-seach-wrap">
<!--            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">-->
<!--                <el-form-item label="试卷">-->
<!--                    <el-input v-model="query.keyword" placeholder="试卷标题" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="用户">-->
<!--                    <el-input v-model="query.keyword_user" placeholder="用户名称" clearable></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="考试时间">-->
<!--                    <div class="block">-->
<!--                        <span class="demonstration"></span>-->
<!--                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->
<!--                    </div>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
        </div>
        <!--内容-->
        <div class="product-content">

            <div class="operation-wrap" style="background-color: #FFFFFF;">
                <el-row>
                    <el-col :span="6" class="d-c-c">
                        <div class="grid-content blue">
                            <div class="info">
                                <h3>{{ detail.view_count ? detail.view_count: 0 }}</h3>
                                <p>打开次数</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" class="d-c-c">
                        <div class="grid-content blue">
                            <div class="info">
                                <h3>{{ detail.comment_count ? detail.comment_count: 0 }}</h3>
                                <p>弹幕条数</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" class="d-c-c">
                        <div class="grid-content  blue">
                            <div class="info">
                                <h3>{{ detail.sign_count ? detail.sign_count: 0 }}</h3>
                                <p>签名数量</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </div>
    </div>
</template>

<script>
    import { vrDetail, examDel } from '@/api/education';

    export default {
        components: {
            /*编辑组件*/
            // Detail,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    create_time: '',
                    keyword: '',
                    keyword_user: '',
                    page: 1,
                    list_rows: 10,
                },
                detail: [],
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                vrDetail(this.query).then((result)=>{
                    this.loading = false
                    this.detail = result.data
                    console.log(result, 'vrDetail')
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
        }
    };
</script>

<style>

    .operation-wrap {
        display: flex;
        width: 100%;
        height: 164px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0 20px;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: hidden;
        background-size: 100% 100%;
        color: #ffffff;
    }

    .operation-wrap .grid-content {
        width: 90%;
        justify-content: flex-start;
        align-items: center;

    }

    .operation-wrap .grid-content.blue {
        background-color: #40ade3;
        background-size: 100% 100%;
    }

    .operation-wrap .grid-content{
        border-radius: 10px;
    }

    .operation-wrap .grid-content .info h3 {
        font-size: 40px;
        line-height: 60px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }

    .operation-wrap .grid-content .info p {
        font-size: 20px;
        line-height: 40px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }

    .operation-wrap .grid-content .info {
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
        height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

</style>



// WEBPACK FOOTER //
// src/views/education/vr/vr/index.vue